import { render, staticRenderFns } from "./web-audiencead-edit.vue?vue&type=template&id=5e14643a&scoped=true&"
import script from "./web-audiencead-edit.vue?vue&type=script&lang=js&"
export * from "./web-audiencead-edit.vue?vue&type=script&lang=js&"
import style0 from "./web-audiencead-edit.vue?vue&type=style&index=0&id=5e14643a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e14643a",
  null
  
)

export default component.exports